import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import lodash from "lodash";
import ErrorIcon from "../assets/SVG/icons/error-icon.svg";
import "../styles/termsandconditionolduser.css";
import { updateUserConsent } from "../api";

const TermsAndConditionOldUser = (props) => {
  const user = useSelector((state) => state.user);
  const history = useHistory();
  const [useImagesForTrainning, setUseImagesForTraining] = useState(user?.agreement?.useImagesForTrainning || false);
  const [consentForMarketing, setConsentForMarketing] = useState(user?.agreement?.consentForMarketing || false);
  const [privacyPolicy, setPrivacyPolicy] = useState(user?.agreement?.privacyPolicy || false);
  const [ageAgreed, setAgeAgreed] = useState(user?.agreement?.ageAgreed || false);
  const [showError, setShowError] = useState(false);
  const [ageAgreedError, setAgeAgreedError] = useState(false);
  const [disableButtonl, setDisableButton] = useState(false);

  useEffect(() => {
    if (lodash.isEmpty(user)) {
      history.push("/login");
    }
  });

  const acceptHandle = async () => {
    setDisableButton(true);
    const payload = {
      ageAgreed,
      ageAgreedOn: new Date(),
      privacyPolicy,
      privacyPolicyAgreedOn: new Date(),
      useImagesForTrainning,
      useImagesForTrainningAgreedOn: useImagesForTrainning ? new Date() : null,
      consentForMarketing,
      consentForMarketingAgreedOn: consentForMarketing ? new Date() : null,
    };
    if (ageAgreed && privacyPolicy) {
      await updateUserConsent(user.uid, payload);
      setDisableButton(false);
      history.push("/home");
      return;
    }
    if (!privacyPolicy) setShowError(true);
    if (!ageAgreed) setAgeAgreedError(true);
    window.scrollTo(0, 0);
    setDisableButton(false);
  };

  const setAgeAgreedHandler = () => {
    setAgeAgreed(!ageAgreed);
    setAgeAgreedError(false);
  };
  const setPrivacyPolicyHandler = () => {
    setPrivacyPolicy(!privacyPolicy);
    setShowError(false);
  };

  return (
    <div className="tnc-wrapper" data-testid="tnc-wrapper">
      <div className="container-item">
        <div className="age-agreement" data-testid="age-agreement">
          <input
            type="checkbox"
            id="ageAgreed"
            data-testid="ageAgreed"
            className="agree-age-checkbox"
            onChange={setAgeAgreedHandler}
            checked={ageAgreed}
          />
          <div>I certify that I'm at least 18 year old.</div>
        </div>

        {ageAgreedError && (
          <div data-testid="missing-age-agreement-old" className="missing-age-agreement-old">
            <img src={ErrorIcon} alt="ageError" />
            <div>You must be at least 18 to use this platform.</div>
          </div>
        )}
      </div>
      <div className="tnc-content" data-testid="tnc-content">
        <div className="container-item">
          <p>
            When you use our Testing applications then you will need to register some basic identity information with us
            so that we can communicate with you if needed, and to track your testing history so that we can advise you
            on things like the recommended Testing intervals etc. You will need to establish a password to protect the
            information. We do not use this information for any marketing, advertising and similar purposes. If you
            choose not to consent to these uses, we will not be able to provide you with the Testing services. We will
            retain the above information for 6 months after you last use the service (unless you request us to delete it
            prior to that). If you wish to use the service again after this you will need to register again, your
            previous testing information will not be available. All data we collect is protected by encrypting it, as
            well as implementing other security best practices.
          </p>
          <div className="basic-tnc">
            <input
              type="checkbox"
              id="basic-tnc"
              data-testid="basic-tnc"
              onChange={setPrivacyPolicyHandler}
              checked={privacyPolicy}
            />
            <div>I consent to the above uses.(required)</div>
          </div>
          {showError && (
            <div className="consent-error" data-testid="consent-error">
              <img src={ErrorIcon} alt="consent-error" className="consent-error-icon" />{" "}
              <span className="agreement-missing">Missing agreement</span>
            </div>
          )}
        </div>
        <div className="container-item">
          <p>
            We may occasionally email you about new tests, services, or service updates. 
            If you opt in, we'll retain your contact info for 24 months after your last use, 
            but you can unsubscribe anytime. Not subscribing won't impact your testing services, 
            and we won't share data for marketing.
          </p>
          <div className="communication-tnc">
            <input
              type="checkbox"
              id="communication-tnc"
              data-testid="communication-tnc"
              onChange={() => setConsentForMarketing(!consentForMarketing)}
              checked={consentForMarketing}
            />
            <div>I’m OK with that.</div>
          </div>
        </div>
        <div className="container-item">
          <p>
            Over time we do plan to provide additional tests for other medical conditions. To develop and test the new
            applications that perform them we need to “train” the new applications. We would be very grateful if you
            would allow us to retain your photo images collected (without other identifying data) and to use them for
            this purpose. Access to the images will be strictly controlled and overseen by a Head of Research for the
            new Application. We would like to retain these images for a period of 5 years. You may request us to delete
            the images at any point. To allow us to do this we will retain basic identity information so we can identify
            the images to delete. Not opting into this secondary use of your images does not affect your ability to use
            the testing service. No data will be shared for the purpose of marketing.
          </p>
          <div className="tests-tnc">
            <input
              type="checkbox"
              id="tests-tnc"
              data-testid="tests-tnc"
              onChange={() => setUseImagesForTraining(!useImagesForTrainning)}
              checked={useImagesForTrainning}
            />
            <div>I understand this additional use of my data and consent to it.</div>
          </div>
        </div>
        <p>
          Please refer to our <a href="https://www.aiztechlabs.com/privacy" target="_blank">Privacy Policy</a> for more details. You can
          contact our Privacy Office at privacy@aiztechlabs.com.{" "}
        </p>
      </div>
      <div className="cta">
        <div className="cta-accept">
          <button
            className="cta-accept-button"
            data-testid="cta-accept"
            onClick={acceptHandle}
            disabled={disableButtonl}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionOldUser;
